//#region  Imports

import { Injectable } from '@angular/core';

//#endregion

@Injectable({
  providedIn: 'root',
})
export class SessionStorage {

  //#region Public Methods

  public setItem<T>(key: string, item: T): void {
    sessionStorage.setItem(key, JSON.stringify(item));
  }

  public getItem<T>(key: string): T | null {
    const item = sessionStorage.getItem(key);

    if (item)
      return JSON.parse(item) as T;

    return null;
  }

  public remove(key: string): void {
    sessionStorage.removeItem(key);
  }

  public clear(): void {
    sessionStorage.clear();
  }

  //#endregion

}
